import { useState, useEffect, useCallback } from 'react';
import { _getTeamBalance, _getAnalytics } from 'controllers/lead-assignments/lead-assignments-controller';

export const useTeamBalance = () => {
  const [teamBalance, setTeamBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTeamBalance = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await _getTeamBalance();
      const data = await response.json();
      setTeamBalance(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeamBalance();
  }, [fetchTeamBalance]);

  return {
    teamBalance,
    loading,
    error,
    fetchTeamBalance,
  };
};

export const useTeamAnalytics = ({ from, to }) => {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAnalytics = useCallback(async ({ from, to }) => {
    setLoading(true);
    setError(null);
    try {
      const response = await _getAnalytics({ from, to });
      const data = await response.json();
      setAnalytics(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAnalytics({ from, to });
  }, [fetchAnalytics]);

  return {
    analytics,
    loading,
    error,
    fetchAnalytics,
  };
};
